import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import * as Highcharts from "highcharts";
import HistogramModule from "highcharts/modules/histogram-bellcurve";
import { BatteryType, EventService } from "src/app/services/event.service";

HistogramModule(Highcharts); // Initialize the histogram module
interface Signal {
  signal: string;
  data_type: string;
  label: string;
}

export interface DataByBatteryType {
  signalsList: Signal[];
  productsList: string[];
  variantList: Record<string, string[]>;
  rigsList: string[];
  batteryType: BatteryType;
}

@Component({
  selector: "app-histogram",
  templateUrl: "./histogram.component.html",
  styleUrls: ["./histogram.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class HistogramComponent implements OnInit {
  constructor(private eventService: EventService) {}

  tgPackData: DataByBatteryType = null;
  plPackData: DataByBatteryType = null;

  ngOnInit(): void {
    this.eventService.getHistogramSignalsList().subscribe((res) => {
      if (res.success) {
        const { piccolo: pl, tg } = res.data;

        this.tgPackData = {
          signalsList: tg.signals,
          batteryType: "tg",
          productsList: tg.products,
          variantList: tg.variants,
          rigsList: tg.rigs,
        };

        this.plPackData = {
          signalsList: pl.signals,
          batteryType: "piccolo",
          productsList: pl.products,
          variantList: pl.variants,
          rigsList: pl.rigs,
        };
      }
    });
  }
}
